import {
  FileAddOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Alert, Col, Radio, Row } from "antd";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import { ALMSG_TIMEOUT } from "../env";
import AddExamModal from "../exams/AddExamModal";
import EditPatientInfo, { PatientFormType } from "./EditPatientInfo";
import { emptyPatient, Patient } from "./interfaces";
import { getPatient } from "./utils";
import PatientPosturalExamsTable from "./PatientPosturalExamsTable";
import PlusbuttonExam from "../buttons/plusbuttonexams";
import PhysioChat from "../chat/PhysioChat";

const selExamsEditOptions = [
  { value: "exams", label: "Scheda clinica" },
  { value: "edit", label: "Dati paziente" },
];

const PatientSheet = () => {
  const { id } = useParams();
  const [patient, setPatient] = useState(emptyPatient);
  const [loading, setLoading] = useState(true);
  const [delSuccess, setDelSuccess] = useState("");
  const [addExamVisible, setAddExamVisible] = useState(false);
  const [selExamsEdit, setSelExamsEdit] = useState(
    selExamsEditOptions[0].value
  );

  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;

  useEffect(() => {
    if (delSuccess != "") setTimeout(() => setDelSuccess(""), ALMSG_TIMEOUT);
  }, [delSuccess]);

  useEffect(() => {
    const idInt:number = parseInt(id || "-1");
    getPatient(signedInDoctor, idInt, (idInt > 0))
      .then((fetchedPatient: Patient) => {
        setPatient({
          ...fetchedPatient,
        });
      })
      .catch((err) => console.error(err));
  }, [signedInDoctor]);

  //LEO

  //LEO

  useEffect(() => {
    if (patient.id) {
      patient.telephoneD =
        patient.telephone.length == 13 && patient.telephone[0] == "+"
          ? patient.telephone.substring(3) //delete prefix from visualization, e.g. +39
          : patient.telephone;
      setLoading(false);
    }
  }, [patient]);

  return (
    <>
      <div className="centered">
        <h3 className="section-title">
        
          {patient.name} {patient.surname}
        </h3>
      </div>
      {!loading && (
        <>
          <Row>
            <Col span={1}></Col>
            <Col span={22}>
              <Row style={{ marginBottom: "2%" }}>
                <Radio.Group
                  onChange={(e) => setSelExamsEdit(e.target.value)}
                  options={selExamsEditOptions}
                  value={selExamsEdit}
                  defaultValue={selExamsEdit}
                  optionType="button"
                  buttonStyle="solid"
                />
              </Row>

              <Row>
                <Col span={24}>
                  {selExamsEdit == "edit" && (
                    <>
                      <h3 style={{ fontWeight: "bold" }}>
                        Edita i dati del paziente
                      </h3>
                      <EditPatientInfo
                        formType={PatientFormType.EDIT}
                        setBasePatient={setPatient}
                        basePatient={patient}
                      />
                    </>
                  )}

                  {selExamsEdit == "exams" && (
                    <>
                      <div className="centered exgh">
                        <button
                          className="traspoz"
                          onClick={() => setAddExamVisible(true)}
                        >
                          <PlusbuttonExam />
                        </button>

                        <AddExamModal
                          visible={addExamVisible}
                          setVisible={setAddExamVisible}
                          selectedPatient={patient}
                        />
                      </div>
                      <div className="centered exght">
                        <button
                          className="traspozas"
                          onClick={() => setAddExamVisible(true)}
                        >
                          <span className="buttonc__icon">
                            <FileAddOutlined rev={undefined} />
                          </span>
                        </button>

                        <div>
                          <AddExamModal
                            visible={addExamVisible}
                            setVisible={setAddExamVisible}
                            selectedPatient={patient}
                          />
                        </div>
                      </div>
                      <PatientPosturalExamsTable
                        patient={patient}
                        setExamDelSuccess={setDelSuccess}
                      />
                    </>
                  )}
                </Col>
              </Row>
            </Col>
            <Col span={1}></Col>
          </Row>
          {delSuccess && (
            <div
              style={{
                marginLeft: "5%",
                marginRight: "5%",
                marginBottom: "16px",
                marginTop: "16px",
              }}
            >
              {delSuccess}
              <Alert
                message="Operazione riuscita"
                description="I dati relativi all'esame selezionato sono stati rimossi"
                type="success"
                showIcon
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default PatientSheet;
function handleResize(this: Window, ev: UIEvent) {
  throw new Error("Function not implemented.");
}
